import AppConfig from '@config';
import { CapaQuotationServiceType } from '@generated/graphql';

export const getFileUrl = (fileId: string) => {
  return `${AppConfig.fileApiUrl}/file/${fileId}`;
};

export const getConnectFileUrl = (fileId: string, fileExtension: string) => {
  return `${AppConfig.hoopsViewerAPI}/${fileId}.${fileExtension}`;
};

export const getDrawingFileThumnailUrl = (fileId: string) => {
  return `${AppConfig.hoopsViewerUrl}/${fileId}.png`;
};
export const getImageUrl = (
  fileId: string,
  serviceType?: CapaQuotationServiceType
) =>
  serviceType === CapaQuotationServiceType.Design
    ? `${AppConfig.fileApiUrl}/file/${fileId}`
    : `${AppConfig.capaViewerApi}/${fileId}.png`;
